import React from 'react';
import * as Yup from 'yup';
import {Formik} from 'formik';
import {Box, Button, Container, makeStyles, TextField, Typography} from '@material-ui/core';
import Page from '../../components/Page';
import {useDispatch, useSelector} from "react-redux";
import {Alert} from "@material-ui/lab";
import {NavLink as RouterLink} from "react-router-dom";
import {registerLogin} from "../../redux/actions/authAction";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        height: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    }
}));

const SignUp = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {error, errorMessage} = useSelector(state => state.auth);
    const handleSubmit = (values, setSubmitting) => {
        dispatch(registerLogin(values.username, values.password, values.name, values.surname, values.smartPiggyID, setSubmitting));
    };


    return (
        <Page
            className={classes.root}
            title="Sing Up"
        >
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
            >
                <Container maxWidth="sm">
                    <Formik
                        initialValues={{
                            name: '',
                            surname: '',
                            smartPiggyID: '',
                            username: '',
                            password: ''
                        }}
                        validationSchema={Yup.object().shape({
                            name: Yup.string().max(25).required('Name is required'),
                            surname: Yup.string().max(25).required('Surname is required'),
                            smartPiggyID: Yup.string().max(25).required('Smart Piggy ID is required'),
                            username: Yup.string().max(25).required('Username is required'),
                            password: Yup.string().max(25).required('Password is required')
                        })}
                        onSubmit={(values, {setSubmitting}) => {
                            handleSubmit(values, setSubmitting);
                        }}
                    >
                        {({
                              errors,
                              handleBlur,
                              handleChange,
                              handleSubmit,
                              isSubmitting,
                              touched,
                              values
                          }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mb={3}>
                                    <Typography color="textPrimary" variant="h2"> Smart Piggy </Typography>
                                    <Typography color="textSecondary" gutterBottom variant="body2">
                                        Sign up
                                    </Typography>
                                </Box>
                                {error && <Alert severity="error">{errorMessage}</Alert>}
                                <TextField
                                    error={Boolean(touched.name && errors.name)}
                                    fullWidth
                                    helperText={touched.name && errors.name}
                                    label="Name"
                                    margin="normal"
                                    name="name"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="text"
                                    value={values.name}
                                    variant="outlined"
                                />
                                <TextField
                                    error={Boolean(touched.surname && errors.surname)}
                                    fullWidth
                                    helperText={touched.surname && errors.surname}
                                    label="Surname"
                                    margin="normal"
                                    name="surname"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="text"
                                    value={values.surname}
                                    variant="outlined"
                                />
                                <TextField
                                    error={Boolean(touched.smartPiggyID && errors.smartPiggyID)}
                                    fullWidth
                                    helperText={touched.smartPiggyID && errors.smartPiggyID}
                                    label="Smart Piggy ID"
                                    margin="normal"
                                    name="smartPiggyID"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="text"
                                    value={values.smartPiggyID}
                                    variant="outlined"
                                />
                                <TextField
                                    error={Boolean(touched.username && errors.username)}
                                    fullWidth
                                    helperText={touched.username && errors.username}
                                    label="Username"
                                    margin="normal"
                                    name="username"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="text"
                                    value={values.username}
                                    variant="outlined"
                                />
                                <TextField
                                    error={Boolean(touched.password && errors.password)}
                                    fullWidth
                                    helperText={touched.password && errors.password}
                                    label="Password"
                                    margin="normal"
                                    name="password"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    type="password"
                                    value={values.password}
                                    variant="outlined"
                                />
                                <Box my={2}>
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting}
                                        fullWidth
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                    >
                                        Register
                                    </Button>
                                </Box>
                                <Box my={2}>
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting}
                                        fullWidth
                                        size="large"
                                        component={RouterLink}
                                        to={"/"}
                                        variant="contained"
                                    >
                                        Already a Member? Login
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Box>
        </Page>
    );
};

export default SignUp;